<template>
  <div class="course-card-v2" @click="handleClick">
    <div class="course-cover-wrap">
      <img class="hoverTransform" :src="item.mainImage || item.image" />
    </div>

    <div class="course-info">
      <div class="course-title textOverflowTwo">
        {{ item.name || item.title }}
      </div>
      <div class="course-meta">
        <div class="equity-icons" v-if="equityClassName.length">
          <img
            v-for="lvl in equityClassName"
            :key="lvl"
            :src="require(`@/assets/images/${lvl}.png`)"
            class="course-equity-badge"
            :alt="lvl"
          />
        </div>
        <div class="views-count">
          <i class="el-icon-view"></i>
          <span>{{ item.viewCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseCard",
  props: {
    // 课程项数据
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 等级专属背景色枚举
    backGround: {
      type: Object,
      default: () => ({
        L1: "rgba(0, 216, 195, 0.1)",
        L2: "rgba(240, 193, 11, 0.1)",
        L3: "rgba(71, 177, 226, 0.1)",
        L4: "rgba(147, 93, 228, 0.1)",
      }),
    },
    // 等级专属字体颜色枚举
    colorEnum: {
      type: Object,
      default: () => ({
        L1: "#00D8C3",
        L2: "#F0C10B",
        L3: "#47B1E2",
        L4: "#935DE4",
      }),
    },
  },
  computed: {
    // 格式化后的已观看时长
    formattedViewTime() {
      return this.formatMinutes(this.item.viewTime || 0);
    },
    // 格式化后的总时长
    formattedDurationTotal() {
      return this.formatMinutes(this.item.durationNumTotal || 0);
    },
    // 解析出该课程适用的等级数组
    equityClassName() {
      let names = this.item.equityClassName;
      if (!names) return [];

      let list = [];
      if (Array.isArray(names)) {
        list = names;
      } else if (typeof names === "string") {
        list = names.split(",");
      }

      const validLevels = ["L1", "L2", "L3", "L4"];
      return [...new Set(list.map((s) => s.trim()))].filter((s) =>
        validLevels.includes(s)
      );
    },
  },
  methods: {
    /**
     * 格式化秒数为中文分钟/秒描述形式
     * @param {number} seconds - 秒数
     * @returns {string} 格式化后的字符串描述
     */
    formatMinutes(seconds) {
      if (!seconds) {
        return "0秒";
      } else if (seconds < 60) {
        return seconds + "秒";
      } else {
        return Math.floor(seconds / 60) + "分钟";
      }
    },
    /**
     * 点击卡片时的事件处理
     * @returns {void}
     */
    handleClick() {
      this.$emit("click", this.item);
    },
  },
};
</script>

<style lang="less" scoped>
.course-card-v2 {
  background: white;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid rgba(186, 202, 198, 0.2);
  // display: flex;

  width: 100%;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.course-cover-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  position: relative;
  background: #f6f3f2;
  img {
    width: 100%;
    height: 100%;
  }
  .study-time-tag {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 6px 12px;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(2px);
    box-sizing: border-box;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC, sans-serif;
    font-weight: 400;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.course-info {
  padding: 20px 20px 15px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
}

.course-title {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
  min-height: 44px;
}

.course-meta {
  width: 100%;
  padding-top: 16px;
  border-top: 1px solid rgba(186, 202, 198, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .equity-icons {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .course-equity-badge {
    width: 24px;
    height: 18px;
    object-fit: contain;
  }
  .views-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 500;
    color: #6b7a77;
    display: block;
    i {
      font-size: 14px;
      color: #00d8c3;
      margin-right: 4px;
    }
  }
}

.hoverTransform {
  transition: transform 0.3s ease;
}
.hoverTransform:hover {
  transform: scale(1.04);
}
</style>
